/* ==========================================================================
   BOZ3D product page
   - variant picker (options -> variant, price, availability, URL, image)
   - gallery thumbnails
   - quantity stepper with live line total
   - personalization character counter + file name display
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.boz-pdp');
  if (!root) return;

  var dataEl = document.querySelector('[data-boz-variants]');
  var variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    variants = [];
  }

  var idInput = root.querySelector('[data-boz-variant-id]');
  var priceEl = root.querySelector('[data-boz-price]');
  var compareEl = root.querySelector('[data-boz-compare]');
  var pay4El = root.querySelector('[data-boz-pay4]');
  var addBtn = root.querySelector('[data-boz-add-button]');
  var addLabel = root.querySelector('[data-boz-add-label]');
  var qtyInput = root.querySelector('[data-boz-qty-input]');
  // Selected structurally, not by a data attribute: Shopify's `image_tag` filter
  // silently drops hyphenated data-* arguments, so `data-boz-gallery-main` never
  // makes it into the markup.
  var mainImg = root.querySelector('.boz-pdp__main img');

  var moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

  function formatMoney(cents) {
    // Mirrors Shopify's money filter for the common formats. Falls back to a
    // plain dollar amount if the shop uses a format we do not recognise.
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withCents = whole + '.' + parts[1];

    if (moneyFormat.indexOf('amount_no_decimals') !== -1) {
      return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole);
    }
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, withCents);
  }

  /* ------------------------------------------------------- variant picker */

  function selectedOptions() {
    var fieldsets = root.querySelectorAll('[data-boz-option-index]');
    var values = [];
    fieldsets.forEach(function (fs) {
      var checked = fs.querySelector('[data-boz-option-input]:checked');
      values.push(checked ? checked.value : null);
    });
    return values;
  }

  function findVariant(values) {
    return variants.find(function (v) {
      return values.every(function (val, i) {
        return v.options[i] === val;
      });
    });
  }

  // Grey out option values that cannot be reached from the current selection.
  function refreshAvailability(values) {
    root.querySelectorAll('[data-boz-option-index]').forEach(function (fs, index) {
      fs.querySelectorAll('[data-boz-option-input]').forEach(function (input) {
        var probe = values.slice();
        probe[index] = input.value;

        var reachable = variants.some(function (v) {
          if (!v.available) return false;
          return probe.every(function (val, i) {
            // Only constrain options up to and including this one; later options
            // are still free to change.
            if (i > index) return true;
            return val === null || v.options[i] === val;
          });
        });

        input.disabled = !reachable;
      });
    });
  }

  function updateLineTotal(variant) {
    if (!addLabel || !variant || !variant.available) return;
    var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
    var total = variant.price * qty;
    addLabel.innerHTML =
      'Add to cart &mdash; <span data-boz-line-total>' + formatMoney(total) + '</span>';
  }

  function applyVariant(variant) {
    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
      }
      if (idInput) idInput.disabled = true;
      return;
    }

    if (idInput) {
      idInput.value = variant.id;
      idInput.disabled = !variant.available;
    }

    if (priceEl) priceEl.textContent = variant.price_formatted;

    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = variant.compare_formatted;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (pay4El) {
      var provider = pay4El.dataset.provider || 'Shop Pay';
      pay4El.textContent =
        '4 × ' + formatMoney(Math.round(variant.price / 4)) + ' with ' + provider;
      // Shop Pay Installments has a $35 order minimum
      pay4El.hidden = variant.price < 3500;
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (!variant.available && addLabel) addLabel.textContent = 'Sold out';
    }

    if (variant.available) updateLineTotal(variant);

    if (variant.featured_image && mainImg) {
      mainImg.src = variant.featured_image;
      mainImg.srcset = '';
    }

    // Keep the URL shareable and the back button meaningful.
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function onOptionChange() {
    var values = selectedOptions();

    root.querySelectorAll('[data-boz-option-index]').forEach(function (fs, index) {
      var label = fs.querySelector('[data-boz-option-value="' + index + '"]');
      if (label && values[index]) label.textContent = values[index];
    });

    refreshAvailability(values);
    applyVariant(findVariant(values));
  }

  root.addEventListener('change', function (event) {
    if (event.target.matches('[data-boz-option-input]')) onOptionChange();
  });

  /* ------------------------------------------------------------- quantity */

  root.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-boz-qty]');
    if (!btn || !qtyInput) return;
    event.preventDefault();
    var step = parseInt(btn.getAttribute('data-boz-qty'), 10);
    var next = (parseInt(qtyInput.value, 10) || 1) + step;
    qtyInput.value = next < 1 ? 1 : next;
    updateLineTotal(findVariant(selectedOptions()));
  });

  if (qtyInput) {
    qtyInput.addEventListener('input', function () {
      updateLineTotal(findVariant(selectedOptions()));
    });
  }

  /* -------------------------------------------------------------- gallery */

  root.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-boz-gallery-thumb]');
    if (!thumb || !mainImg) return;
    event.preventDefault();
    mainImg.src = thumb.getAttribute('data-full');
    mainImg.srcset = '';
    mainImg.alt = thumb.getAttribute('data-alt') || '';
    root.querySelectorAll('[data-boz-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* ------------------------------------------------------ personalization */

  var counterInput = root.querySelector('[data-boz-counter-input]');
  var counterOut = root.querySelector('[data-boz-counter-output]');
  if (counterInput && counterOut) {
    counterInput.addEventListener('input', function () {
      counterOut.textContent = counterInput.value.length;
    });
  }

  var fileInput = root.querySelector('[data-boz-upload-input]');
  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var wrap = root.querySelector('[data-boz-upload]');
      var label = root.querySelector('[data-boz-upload-label]');
      var sub = root.querySelector('[data-boz-upload-sub]');
      var file = fileInput.files && fileInput.files[0];

      if (file) {
        // Shopify rejects line item property uploads over 20MB — catch it here
        // rather than letting the add-to-cart fail with a vague error.
        if (file.size > 20 * 1024 * 1024) {
          fileInput.value = '';
          if (label) label.textContent = 'That file is over 20MB — please pick a smaller one';
          if (sub) sub.textContent = 'PNG, JPG or PDF';
          if (wrap) wrap.classList.remove('is-filled');
          return;
        }
        if (label) label.textContent = file.name;
        if (sub) sub.textContent = 'Attached — tap to replace';
        if (wrap) wrap.classList.add('is-filled');
      } else {
        if (label) label.textContent = 'Upload your logo or design';
        if (sub) sub.textContent = 'or drop a file here';
        if (wrap) wrap.classList.remove('is-filled');
      }
    });
  }

  /* ------------------------------------------------------------- init */

  if (variants.length) onOptionChange();
})();
